export class LazyLoader {
    constructor(options = {}) {
        this.rootMargin = options.rootMargin || '0px 0px 400px 0px';
        this.threshold = options.threshold || 0.1;
        this.lowResSuffix = options.lowResSuffix || '-low';
        this.fallbackSrc = options.fallbackSrc || '/templates/Goya/assets/images/placeholder.png';
    }

    getOptions(el) {
        return {
            rootMargin: el.getAttribute('data-root-margin') || this.rootMargin,
            threshold: parseFloat(el.getAttribute('data-threshold')) || this.threshold,
            fallbackSrc: el.getAttribute('data-fallback') || this.fallbackSrc
        };
    }

    supportsWebP() {
        return document.createElement('canvas')
            .toDataURL('image/webp')
            .startsWith('data:image/webp');
    }

    getSrc(el) {
        const highRes = el.getAttribute('data-src');
        if (!highRes) {
            console.warn('Missing data-src attribute on element:', el);
            return this.fallbackSrc;
        }

        const isSlow = navigator.connection?.saveData ||
            navigator.connection?.effectiveType?.includes('2g');


        // Формируем low-res URL
        const lowRes = el.getAttribute('data-low-res-src') ||
            highRes.replace(
                /\.(jpe?g|png)(\?[^#]*)?(#[^#]*)?$/i,
                `${this.lowResSuffix}.$1$2$3`
            );

        // Проверяем поддержку WebP
        const supportsWebP = this.supportsWebP();

        if (isSlow && lowRes) return lowRes;
        if (supportsWebP) return highRes.replace(/\.(jpe?g|png)$/i, '.webp');

        return highRes;
    }

    init() {
        if (!('IntersectionObserver' in window)) {
            console.warn('IntersectionObserver not supported. Falling back to load all images.');
            this.loadAll();
            return;
        }

        document.querySelectorAll('[data-lazy]').forEach((img) => {
            const options = this.getOptions(img);

            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.loadImage(entry.target);
                        observer.unobserve(entry.target);
                    }
                });
            }, options);

            observer.observe(img);
        });
    }

    loadImage( img ) {

        // Обработчики событий
        const onLoad = () => {
            img.classList.add('loaded');
            img.removeAttribute('data-lazy');
            img.removeEventListener('load', onLoad);
            img.removeEventListener('error', onError);
        };

        const onError = () => {
            const options = this.getOptions(img);
            img.src = options.fallbackSrc;
            img.classList.add('loaded');
            img.classList.add('error');
            img.removeEventListener('load', onLoad);
            img.removeEventListener('error', onError);
        };

        img.addEventListener('load', onLoad);
        img.addEventListener('error', onError);

        // Обработка <picture>
        if (img.tagName === 'PICTURE') {
            img.querySelectorAll('source').forEach(source => {
                const srcset = this.getSrc(source);
                source.setAttribute('srcset', srcset);
            });

            const imgEl = img.querySelector('img');
            if (imgEl) {
                imgEl.src = this.getSrc(imgEl);
            }
        } else {
            // Обычная img
            img.src = this.getSrc(img);
        }
    }

    loadAll() {
        document.querySelectorAll('[data-lazy]').forEach((img) => {
            this.loadImage(img);
        });
    }

    destroy() {}
}
